export const GET_USER_LOCATION = 'GET_USER_LOCATION';
export const getUserLocation = () => (dispatch) => {
    const { geolocation } = navigator;
    geolocation.getCurrentPosition((position) => {
        dispatch({
            type: GET_USER_LOCATION,
            position,
        });
    });
};
